import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KeBuildVersionService extends ReplaySubject<string> {
  constructor() {
    super(1);
  }
}
